import { Spin } from 'antd';

export default function LoadingFallback() {
  return (
    <div className="flex items-center justify-center h-screen">
      <Spin size="large" />
      <p className="text-lg font-bold">Loading...</p>
    </div>
  );
}
